<section class="pb-3 bg-white px-4 sm:px-6 lg:px-8">
  <div class="flex flex-wrap gap-3 justify-between items-start w-full max-md:max-w-full">
    <div class="w-full flex flex-col gap-2 pt-2" *ngIf="isMobile">
      <!-- Search + View Toggle Row -->
      <div class="flex items-center gap-2 px-1">
        <!-- Search Bar -->
        <div class="relative flex-grow">
          <input type="text" [placeholder]="
              partType === 'Used Part'
                ? 'Search by part name'
                : 'Search by scrap name'
            " [(ngModel)]="searchText" (input)="onSearchInput($event)" (keypress)="onSearchKeyPress($event)"
            class="w-full py-2.5 pl-2 pr-10 rounded-[10px] border border-gray-300 text-sm text-gray-800 placeholder-gray-400 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
          <svg xmlns="http://www.w3.org/2000/svg"
            class="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500 cursor-pointer" fill="none"
            viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" (click)="onSearchSubmit()">
            <path stroke-linecap="round" stroke-linejoin="round"
              d="M21 21l-4.35-4.35M11 18a7 7 0 100-14 7 7 0 000 14z" />
          </svg>
        </div>

        <!-- View Toggle Button -->
        <button (click)="toggleViewmobile()" [ngClass]="{
            'bg-blue-100 text-blue-600': currentView === 'grid',
            'text-blue-600': currentView !== 'grid',
          }" class="p-2 rounded-md">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            *ngIf="currentView === 'grid'" class="w-4 h-4 rounded">
            <path
              d="M3 16V19C3 20.1046 3.89543 21 5 21H8C9.10457 21 10 20.1046 10 19V16C10 14.8954 9.10457 14 8 14H5C3.89543 14 3 14.8954 3 16Z"
              stroke="currentColor" stroke-width="2" />
            <path
              d="M3 5V8C3 9.10457 3.89543 10 5 10H8C9.10457 10 10 9.10457 10 8V5C10 3.89543 9.10457 3 8 3H5C3.89543 3 3 3.89543 3 5Z"
              stroke="currentColor" stroke-width="2" />
            <path
              d="M14 16V19C14 20.1046 14.8954 21 16 21H19C20.1046 21 21 20.1046 21 19V16C21 14.8954 20.1046 14 19 14H16C14.8954 14 14 14.8954 14 16Z"
              stroke="currentColor" stroke-width="2" />
            <path
              d="M14 5V8C14 9.10457 14.8954 10 16 10H19C20.1046 10 21 9.10457 21 8V5C21 3.89543 20.1046 3 19 3H16C14.8954 3 14 3.89543 14 5Z"
              stroke="currentColor" stroke-width="2" />
          </svg>

          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            *ngIf="currentView === 'list'">
            <path
              d="M3 16V19C3 20.1046 3.87123 21 4.94595 21H19.0541C20.1288 21 21 20.1046 21 19V16C21 14.8954 20.1288 14 19.0541 14H4.94595C3.87123 14 3 14.8954 3 16Z"
              [attr.stroke]="currentView === 'list' ? '#3B82F6' : '#A1A9AC'" />
            <path
              d="M3 5V8C3 9.10457 3.87123 10 4.94595 10H19.0541C20.1288 10 21 9.10457 21 8V5C21 3.89543 20.1288 3 19.0541 3H4.94595C3.87123 3 3 3.89543 3 5Z"
              [attr.stroke]="currentView === 'list' ? '#3B82F6' : '#A1A9AC'" />
          </svg>
        </button>
      </div>

      <!-- Filters (pills) -->
      <section class="flex overflow-x-auto gap-2 px-1 no-scrollbar">
        <button *ngFor="let filter of filters"
          class="flex gap-1 items-center py-1.5 px-3 rounded-md sm:rounded-full border border-neutral-300 bg-white whitespace-nowrap text-sm"
          (click)="sideFilterPopup($event)">
          <span class="text-black font-medium">
            {{ filter.label }}
            <!-- <span *ngIf="filter.count !== undefined" class="font-bold">
              ({{ filter.count }})
            </span> -->
          </span>
          <span>
            <svg *ngIf="filter.iconType === 'dropdown'" width="16" height="16" viewBox="0 0 20 20" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path d="M5 7.5L9.41074 11.9107C9.73618 12.2362 10.2638 12.2362 10.5893 11.9107L15 7.5" stroke="black"
                stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </button>
      </section>

      <!-- Selected Filters Pills -->
      <div class="flex flex-wrap gap-2 px-4" *ngIf="(selectedFilters ?? []).length > 0 && hasViewedResults">
        <div *ngFor="let filter of selectedFilters ?? []"
          class="flex items-center gap-1 px-3 py-1.5 rounded-md sm:rounded-full border border-blue-500 bg-blue-50 text-blue-500 text-sm font-medium">
          {{ filter.label }}
          <button class="hover:text-blue-700" (click)="removeFilter(filter.value)">
            ✕
          </button>
        </div>
      </div>
    </div>

    <!-- Filter Options -->
    <section class="flex overflow-x-auto gap-2 md:gap-3 items-center no-scrollbar tabletview" *ngIf="!isMobile">
      <button *ngFor="let filter of filters"
        class="flex gap-1 justify-center items-center py-1 pr-2 pl-3 h-8 bg-white rounded-lg border border-solid border-neutral-300 shrink-0"
        (click)="sideFilterPopup($event)">
        <span class="text-sm font-medium leading-5 text-black">
          {{ filter.label }}
          <span *ngIf="
              getFilterCount(filter.label) > 0 &&
              (selectedFilters ?? []).length > 0 &&
              hasViewedResults
            ">({{ getFilterCount(filter.label) }})</span>
        </span>
        <span>
          <svg *ngIf="filter.iconType === 'dropdown'" width="20" height="20" viewBox="0 0 20 20" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M5 7.5L9.41074 11.9107C9.73618 12.2362 10.2638 12.2362 10.5893 11.9107L15 7.5" stroke="black"
              stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <svg *ngIf="filter.iconType === 'sort'" width="20" height="20" viewBox="0 0 20 20" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path d="M2 16L6 16M2 10L10 10M2 4L14 4" stroke="black" stroke-width="1.5" stroke-linecap="round" />
          </svg>
        </span>
      </button>
    </section>

    <!-- Search and View Toggle -->
    <div class="flex gap-3 min-h-8 min-w-60 tabletSearch" *ngIf="!isMobile">
      <div class="relative w-full max-w-md">
        <input type="text" [placeholder]="
            partType === 'Used Part'
              ? 'Search by part name'
              : 'Search by scrap name'
          " [(ngModel)]="searchText" (input)="onSearchInput($event)" (keypress)="onSearchKeyPress($event)"
          class="w-full py-2.5 pl-2 pr-10 rounded-[10px] border border-gray-300 text-sm text-gray-800 placeholder-gray-400 shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" />
        <svg xmlns="http://www.w3.org/2000/svg"
          class="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500 cursor-pointer" fill="none"
          viewBox="0 0 24 24" stroke="currentColor" stroke-width="2" (click)="onSearchSubmit()">
          <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-4.35-4.35M11 18a7 7 0 100-14 7 7 0 000 14z" />
        </svg>
      </div>
      <!-- View Toggle Button (reuse existing logic/buttons) -->
      <div class="flex gap-1 items-center py-2 pl-1 h-full" role="group" aria-label="View toggle">
        <button (click)="toggleView('grid')" [ngClass]="{
            'text-blue-500': currentView === 'grid',
            'text-gray-400': currentView !== 'grid',
          }">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            class="object-contain shrink-0 self-stretch my-auto w-6 rounded-none aspect-square" alt="List view">
            <path
              d="M3 16V19C3 20.1046 3.89543 21 5 21H8C9.10457 21 10 20.1046 10 19V16C10 14.8954 9.10457 14 8 14H5C3.89543 14 3 14.8954 3 16Z"
              [attr.stroke]="currentView === 'grid' ? '#3B82F6' : '#A1A9AC'" stroke-width="2" />
            <path
              d="M3 5V8C3 9.10457 3.89543 10 5 10H8C9.10457 10 10 9.10457 10 8V5C10 3.89543 9.10457 3 8 3H5C3.89543 3 3 3.89543 3 5Z"
              [attr.stroke]="currentView === 'grid' ? '#3B82F6' : '#A1A9AC'" stroke-width="2" />
            <path
              d="M14 16V19C14 20.1046 14.8954 21 16 21H19C20.1046 21 21 20.1046 21 19V16C21 14.8954 20.1046 14 19 14H16C14.8954 14 14 14.8954 14 16Z"
              [attr.stroke]="currentView === 'grid' ? '#3B82F6' : '#A1A9AC'" stroke-width="2" />
            <path
              d="M14 5V8C14 9.10457 14.8954 10 16 10H19C20.1046 10 21 9.10457 21 8V5C21 3.89543 20.1046 3 19 3H16C14.8954 3 14 3.89543 14 5Z"
              [attr.stroke]="currentView === 'grid' ? '#3B82F6' : '#A1A9AC'" stroke-width="2" />
          </svg>
        </button>
        <div class="shrink-0 self-stretch my-auto w-0 border border-solid bg-neutral-300 border-neutral-300 h-[21px]"
          aria-hidden="true"></div>
        <button (click)="toggleView('list')" [ngClass]="{
            'text-blue-500': currentView === 'list',
            'text-gray-400': currentView !== 'list',
          }">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
              d="M3 16V19C3 20.1046 3.87123 21 4.94595 21H19.0541C20.1288 21 21 20.1046 21 19V16C21 14.8954 20.1288 14 19.0541 14H4.94595C3.87123 14 3 14.8954 3 16Z"
              [attr.stroke]="currentView === 'list' ? '#3B82F6' : '#A1A9AC'" stroke-width="2" />
            <path
              d="M3 5V8C3 9.10457 3.87123 10 4.94595 10H19.0541C20.1288 10 21 9.10457 21 8V5C21 3.89543 20.1288 3 19.0541 3H4.94595C3.87123 3 3 3.89543 3 5Z"
              [attr.stroke]="currentView === 'list' ? '#3B82F6' : '#A1A9AC'" stroke-width="2" />
          </svg>
        </button>
      </div>
    </div>

    <!-- Selected Filters -->
    <!-- Dynamic display for selected filters -->
    <div
      class="flex flex-wrap gap-3 items-center text-sm font-bold leading-none text-blue-500 min-w-60 w-[1311px] max-md:max-w-full"
      *ngIf="
        (selectedFilters ?? []).length > 0 && !isMobile && hasViewedResults
      ">
      <div *ngFor="let filter of selectedFilters ?? []"
        class="flex items-center ml-2 gap-2 px-3 py-1.5 rounded-lg border border-blue-500 bg-blue-50 font-bold text-sm leading-5">
        {{ filter.label }}
        <button class="text-blue-500 hover:text-blue-700" (click)="removeFilter(filter.value)">
          ✕
        </button>
      </div>
    </div>
  </div>
</section>

<!-- verticle filter -->

<!-- category-filter.component.html -->
<section
  class="overflow-hidden bg-white fixed inset-x-0 bottom-0 md:top-0 md:left-0 md:inset-x-auto w-full md:max-w-[484px] h-[85vh] md:h-full shadow-lg transform transition-transform duration-300 z-[100] rounded-t-2xl md:rounded-none" role="dialog" aria-modal="true" aria-label="Filters"
  [ngClass]="
    Sidefilter
      ? 'translate-y-0 md:translate-x-0 md:translate-y-0'
      : 'translate-y-full md:-translate-x-full md:translate-y-0'
  " *ngIf="true">
  <header
    class="flex flex-col justify-center px-6 py-4 w-full text-xl font-medium leading-snug whitespace-nowrap border-b border-solid border-b-[color:var(--Input-field-Stroke,#D4D4D4)] text-blue-950 max-md:px-5 max-md:max-w-full">
    <div class="flex gap-10 justify-between items-start w-full max-md:max-w-full">
      <h2>Filters</h2>
      <button (click)="closeFilters()" aria-label="Close filters">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/b5c5c4f9d14497cda2901f721c278ac9b809c738?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7"
          alt="Close filters" class="object-contain shrink-0 w-8 aspect-square" />
      </button>
    </div>
  </header>

  <div class="w-full max-md:max-w-full h-full overflow-hidden">
    <div class="flex max-md:flex-row h-full overflow-hidden">
      <!-- Left Panel - Filter Navigation -->
      <div class="LeftPanel w-[40%] max-md:ml-0 bg-zinc-100 h-full overflow-hidden mr-4">
        <nav class="overflow-hidden mx-auto w-full text-base font-medium bg-zinc-100 text-black bg-white-100 h-auto">
          <!-- Dynamic filter navigation based on available filters -->
          <button *ngFor="let filter of filters"
            class="gap-2 self-stretch px-6 py-3 w-full whitespace-nowrap max-md:px-5" [ngClass]="{
              'font-bold text-blue-500 bg-white border-r border-white':
                activeTab === filter.label,
            }" (click)="setActiveTab(filter.label)">
            {{ filter.label }}
            <span *ngIf="getFilterCount(filter.label) > 0" class="text-blue-500 font-bold">
              ({{ getFilterCount(filter.label) }})
            </span>
          </button>

          <!-- Vehicle tab (always available) -->
          <button *ngIf="partType === 'Used Part'"
            class="gap-2 self-stretch px-6 py-3 w-full whitespace-nowrap max-md:px-5" [ngClass]="{
              'font-bold text-blue-500 bg-white border-r border-white':
                activeTab === 'Vehicle',
            }" (click)="setActiveTab('Vehicle')">
            Vehicle
            <span *ngIf="getFilterCount('Vehicle') > 0" class="text-blue-500 font-bold">
              ({{ getFilterCount("Vehicle") }})
            </span>
          </button>
        </nav>
      </div>

      <!-- Right Panel - Category Content -->
      <div class="RightPanel w-[68%] max-md:ml-0 max-md:w-full h-full overflow-hidden">
        <section
          class="flex overflow-hidden relative grow justify-between items-start w-full bg-white rounded-lg shadow-sm min-h-[500px] sm:min-h-full">
          <div
            class="z-0 flex-1 shrink pr-3 pt-3 w-full font-medium basis-0 min-w-60 overflow-y-auto no-scrollbar sm:pl-1 sm:mt-2 sm:h-[570px]">
            <!-- Sort By Tab -->
            <div *ngIf="activeTab === 'Sort By'">
              <div class="w-80 h-[500px] p-3 flex flex-col gap-4 overflow-hidden">
                <label *ngFor="let option of sortOptions"
                  class="flex items-center gap-2 cursor-pointer text-base font-medium text-Text-Black">
                  <input type="radio" name="sort" [value]="option.value" [(ngModel)]="selectedSort"
                    (change)="onSortChange()" class="form-radio text-Secondary-Blue focus:ring-Secondary-Blue" />
                  {{ option.label }}
                </label>
              </div>
            </div>

            <div *ngIf="activeTab === 'Vehicle'">
              <section
                class="flex flex-col gap-6 mx-auto max-w-none max-md:p-3 max-md:w-full max-md:max-w-[991px] max-sm:p-2 max-sm:max-w-screen-sm overflow-y-auto no-scrollbar sm:h-[570px]">
                <!-- My Vehicles Section -->
                <section class="flex flex-col gap-4 my-[vehicles]" *ngIf="IMAGES?.length > 0">
                  <header class="flex justify-between items-center text-lg font-bold text-blue-950 max-sm:text-base">
                    <h2>My Vehicles</h2>
                    <span class="text-sm text-black">({{ IMAGES?.length }})</span>
                  </header>

                  <div class="flex flex-row gap-2 overflow-x-auto scrollbar-hide whitespace-nowrap">
                    <div *ngFor="let vehicle of IMAGES" (click)="selectVehicle(vehicle)"
                      class="flex flex-row items-center rounded border border-solid flex-shrink-0 cursor-pointer transition-all duration-200 hover:scale-105 relative"
                      [ngClass]="{
                        'border-blue-500 bg-blue-50 shadow-md px-3 py-2':
                          isVehicleSelected(vehicle),
                        'border-neutral-300 bg-white px-1 py-0':
                          !isVehicleSelected(vehicle),
                      }">
                      <img [src]="vehicle?.image_path" [alt]="vehicle?.make"
                        class="w-4 sm:w-8 h-4 sm:h-8 p-0.5 rounded" />

                      <span *ngIf="!isVehicleSelected(vehicle)"
                        class="text-sm font-bold ml-2 max-sm:text-sm text-black">
                        {{ vehicle?.make }}
                      </span>

                      <!-- <div *ngIf="isVehicleSelected(vehicle)" class="ml-2 flex flex-col">
                        <span class="text-sm font-bold text-blue-600">{{ vehicle?.make }}</span>
                        <div *ngIf="vehicle?.model" class="text-xs text-blue-500">{{ vehicle?.model }}</div>
                        <div *ngIf="vehicle?.year_of_manufacturing" class="text-xs text-blue-500">{{ vehicle?.year_of_manufacturing }}</div>
                        <div *ngIf="vehicle?.variant" class="text-xs text-blue-500">{{ vehicle?.variant }}</div>
                      </div> -->

                      <!-- Selection indicator -->
                      <div *ngIf="isVehicleSelected(vehicle)"
                        class="absolute -top-1 -right-1 w-4 h-4 bg-blue-500 rounded-full flex items-center justify-center">
                        <svg class="w-2 h-2 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path fill-rule="evenodd"
                            d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                            clip-rule="evenodd"></path>
                        </svg>
                      </div>
                    </div>
                  </div>
                </section>

                <!-- Select Vehicle Section -->
                <section class="flex flex-col gap-4">
                  <h2 class="text-lg font-bold text-blue-950 max-sm:text-base">
                    Select Vehicle
                  </h2>

                  <!-- <div class="flex gap-2">
                    <div class="flex gap-1.5 items-center">
                      <div><input type="radio" /></div>
                      <label
                        class="text-base font-bold text-black max-sm:text-sm"
                        >Vehicle model</label
                      >
                    </div>

                    <div class="flex gap-1.5 items-center">
                      <div><input type="radio" /></div>
                      <label
                        class="text-base font-bold text-black max-sm:text-sm"
                      >
                        Registration No.
                      </label>
                    </div>
                  </div> -->
                  <form [formGroup]="vehicleForm">
                    <div class="flex flex-col gap-1 max-md:w-full">
                      <label class="text-xs font-bold text-zinc-700 max-sm:text-xs">
                        Registration no.
                      </label>
                      <div
                        class="self-stretch h-9 px-2 bg-white rounded-lg outline outline-1 outline-offset-[-1px] outline-gray-200 flex justify-between items-center">
                        <input placeholder="E.g RJ14SH1122" formControlName="registrationNo"
                          (input)="onRegistrationNoInput($event)" maxlength="10" minlength="10"
                          style="text-transform: uppercase"
                          class="bg-transparent outline-none text-sm font-medium text-gray-700 w-full font-['Uni_Neue'] placeholder:text-Text-Caption" />
                        <button class="w-6 h-6 flex justify-center items-center ml-2">
                          <!-- Example Search Icon (you can replace with actual SVG or icon component) -->
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                            class="w-4 h-4 text-black">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="M21 21l-4.35-4.35M10.5 17a6.5 6.5 0 100-13 6.5 6.5 0 000 13z" />
                          </svg>
                        </button>
                      </div>
                      <!-- Validation Error Messages -->
                      <div *ngIf="
                          vehicleForm.get('registrationNo')?.invalid &&
                          (vehicleForm.get('registrationNo')?.dirty ||
                            vehicleForm.get('registrationNo')?.touched ||
                            isRegistrationNoEntered)
                        " class="text-red-500 text-xs mt-1">
                        <div *ngIf="
                            vehicleForm.get('registrationNo')?.errors?.[
                              'pattern'
                            ]
                          ">
                          Registration number must be exactly 10 alphanumeric
                          characters
                        </div>
                        <div *ngIf="
                            vehicleForm.get('registrationNo')?.errors?.[
                              'minlength'
                            ] ||
                            vehicleForm.get('registrationNo')?.errors?.[
                              'maxlength'
                            ]
                          ">
                          Registration number must be exactly 10 characters
                        </div>
                      </div>
                      <!-- API Error Message -->
                      <div *ngIf="noVehicleFound" class="text-red-500 text-xs mt-1">
                        No vehicle found for this registration number
                      </div>
                    </div>

                    <div class="w-68 h-px origin-top-left bg-gray-300 rounded-lg mt-[30px] mr-0 mb-[-20px] ml-0"></div>

                    <!-- OR Separator -->
                    <div
                      class="w-[31px] h-[31px] mb-[-6px] ml-[110px] text-sm font-medium leading-5 text-black bg-white border border-solid border-neutral-300 rounded-[32px] flex items-center justify-center md:w-10 md:h-10 md:mt-0 md:mb-0 ortab">
                      OR
                    </div>

                    <!-- Form Fields -->

                    <div class="flex flex-col gap-1 max-md:w-32px max-md:h-[16px] mt-4 sm:mt-0 mb-10 sm:mb-3">
                      <label class="font-semibold text-xs leading-4 align-middle">Brand</label>
                      <select class="px-2 h-9 bg-white rounded-lg border border-stone-300 text-sm text-neutral-700"
                        formControlName="brand" (change)="onBrandSelect($event)" [disabled]="isRegistrationFieldFilled">
                        <option class="text-gray-800 font-medium text-sm leading-5" value="">
                          Select Brand
                        </option>
                        <option *ngFor="let v of brandslist" [value]="v.VEHICLE_MAKE_s">
                          {{ v?.VEHICLE_MAKE_s }}
                        </option>
                      </select>
                    </div>

                    <div class="flex flex-col gap-1 max-md:w-32px max-md:h-[16px] mb-10 sm:mb-3">
                      <label class="font-semibold text-xs leading-4 align-middle">Model</label>
                      <select class="px-2 h-9 bg-white rounded-lg border border-stone-300 text-sm text-neutral-700"
                        formControlName="model" (change)="onModelSelect($event)" [disabled]="isRegistrationFieldFilled">
                        <option value="">Select Model</option>
                        <option *ngFor="let v of modelList" [value]="v.PARENT_MODEL_s">
                          {{ v.PARENT_MODEL_s }}
                        </option>
                      </select>
                    </div>

                    <div class="flex flex-col gap-1 max-md:w-32px max-md:h-[16px] mb-10 sm:mb-3">
                      <label class="font-semibold text-xs leading-4 align-middle">
                        Year
                      </label>
                      <select formControlName="year" (change)="onYearSelect()"
                        class="px-2 h-9 bg-white rounded-lg border border-stone-300 text-sm text-neutral-700"
                        [disabled]="isRegistrationFieldFilled">
                        <option value="">Select Year</option>
                        <option *ngFor="let y of yearList" [value]="y">
                          {{ y }}
                        </option>
                      </select>
                    </div>

                    <div class="flex flex-col gap-1 max-md:w-32px max-md:h-[16px] mb-10 sm:mb-3">
                      <label class="font-semibold text-xs leading-4 align-middle">Variant</label>
                      <select class="px-2 h-9 bg-white rounded-lg border border-stone-300 text-sm text-neutral-700"
                        formControlName="variant" (change)="onVariantSelect()" [disabled]="isRegistrationFieldFilled">
                        <option value="">Select Variant</option>
                        <option *ngFor="let v of varientList" [value]="v">
                          {{ v }}
                        </option>
                      </select>
                    </div>
                  </form>
                </section>
              </section>
            </div>

            <!-- Brand Tab -->
            <div *ngIf="activeTab === 'Brand'">
              <!-- Search Input -->
              <div class="w-full mb-4 relative">
                <input type="text" [(ngModel)]="categorySearch" placeholder="Search Brand"
                  class="w-full p-2 pr-9 rounded-md outline outline-1 outline-gray-300 text-sm placeholder-gray-400" />
                <button type="button"
                  class="absolute top-1/2 right-2 transform -translate-y-1/2 w-6 h-6 flex justify-center items-center">
                  <!-- Search Icon -->
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    class="w-4 h-4 text-gray-500">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M21 21l-4.35-4.35M10.5 17a6.5 6.5 0 100-13 6.5 6.5 0 000 13z" />
                  </svg>
                </button>
              </div>

              <!-- Filtered Categories -->
              <div *ngFor="let category of filteredCategories()"
                class="flex gap-10 justify-between items-center w-full whitespace-nowrap sm:my-2">
                <!-- Checkbox + Label -->
                <div class="flex gap-2 items-center text-base text-black">
                  <div class="flex shrink-0 w-5 h-5 m-1">
                    <input type="checkbox" class="w-4 h-4 rounded" [checked]="category?.selected"
                      (change)="toggleSelectionBrand(category, $event)" />
                  </div>
                  <span>{{ category?.name }}</span>
                </div>

                <!-- Count -->
                <!-- <div class="flex items-center text-xs text-neutral-500 leading-none">
                  <span>({{ category?.count }})</span>
                </div> -->
              </div>
            </div>

            <div *ngIf="activeTab === 'Mfg. Year'" class="overflow-y-auto h-[560px] pr-2 no-scrollbar sm:pl-1 sm:pt-1">
              <ng-container *ngFor="let category of filtersData?.year">
                <div class="mb-4" *ngIf="activeTab == 'Mfg. Year'">
                  <!-- Top Level Category -->
                  <div class="flex gap-8 justify-between items-center w-full whitespace-nowrap">
                    <div class="flex gap-2 items-center self-stretch my-auto text-base text-black">
                      <div class="flex shrink-0 self-stretch my-auto w-5 h-5">
                        <input type="checkbox" class="w-4 h-4 rounded" [checked]="category.selected"
                          (change)="toggleSelection(category, $event)" />
                      </div>
                      <span class="self-stretch my-auto">{{
                        category?.name
                        }}</span>
                    </div>
                    <!-- <div class="flex items-center self-stretch my-auto text-xs leading-none text-neutral-500"> -->
                    <!-- <span class="self-stretch my-auto">({{ category?.count }})</span> -->
                    <!-- <button *ngIf="category.children && category.children.length > 0" (click)="toggleExpand(category)"
                      class="ml-2">
                      <img [src]="
                            category.expanded
                              ? 'https://cdn.builder.io/api/v1/image/assets/TEMP/e00623418da701feb87e5a771cf46df6fd26b971?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7'
                              : 'https://cdn.builder.io/api/v1/image/assets/TEMP/4a08d0b6975bd738fd78e1dd4974551430ef0a2c?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7'
                          " alt="Expand/collapse"
                        class="object-contain shrink-0 self-stretch my-auto w-6 aspect-square" />
                    </button> -->
                    <!-- </div> -->
                  </div>
                </div>
              </ng-container>
            </div>

            <div *ngIf="activeTab === 'Grade'">
              <ng-container *ngFor="let category of filtersData?.quality">
                <div class="mb-4" *ngIf="activeTab == 'Grade'">
                  <!-- Top Level Category -->
                  <div class="flex gap-10 justify-between items-center w-full whitespace-nowrap">
                    <div class="flex gap-2 items-center self-stretch my-auto text-base text-black">
                      <div class="flex shrink-0 self-stretch my-auto w-5 h-5">
                        <input type="checkbox" class="w-4 h-4 rounded" [checked]="category.selected"
                          (change)="toggleSelection(category, $event)" />
                      </div>
                      <span class="self-stretch my-auto">{{
                        category?.name
                        }}</span>
                    </div>
                    <!-- <div class="flex items-center self-stretch my-auto text-xs leading-none text-neutral-500"> -->
                    <!-- <span class="self-stretch my-auto">({{ category?.count }})</span> -->
                    <!-- <button *ngIf="category.children && category.children.length > 0" (click)="toggleExpand(category)"
                      class="ml-2">
                      <img [src]="
                            category.expanded
                              ? 'https://cdn.builder.io/api/v1/image/assets/TEMP/e00623418da701feb87e5a771cf46df6fd26b971?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7'
                              : 'https://cdn.builder.io/api/v1/image/assets/TEMP/4a08d0b6975bd738fd78e1dd4974551430ef0a2c?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7'
                          " alt="Expand/collapse"
                        class="object-contain shrink-0 self-stretch my-auto w-6 aspect-square" />
                    </button> -->
                    <!-- </div> -->
                  </div>
                </div>
              </ng-container>
            </div>
            <div *ngIf="activeTab === 'Price Range'">
              <div class="w-85 p-4 flex flex-col gap-2 bg-white rounded-lg sm:pl-0">
                <!-- Min/Max Inputs -->
                <div class="flex items-end gap-2">
                  <div class="flex-1">
                    <label class="text-sm font-bold text-gray-700">Min</label>
                    <input type="text" [value]="'₹' + formatPrice(minValue)" readonly
                      class="w-full h-10 px-3 border border-gray-300 rounded-lg text-base text-gray-800 font-medium" />
                  </div>
                  <span class="text-sm font-medium text-gray-500">-</span>
                  <div class="flex-1">
                    <label class="text-sm font-bold text-gray-700">Max</label>
                    <input type="text" [value]="'₹' + formatPrice(maxValue)" readonly
                      class="w-full h-10 px-3 border border-gray-300 rounded-lg text-base text-gray-800 font-medium" />
                  </div>
                </div>

                <!-- Range Sliders -->
                <div class="relative h-12">
                  <input type="range" [min]="getSliderMin()" [max]="getSliderMax()" [step]="getSliderStep()"
                    [(ngModel)]="minValue" (input)="onSliderChange()"
                    class="absolute z-10 w-full h-[55px] bg-transparent pointer-events-none appearance-none" />
                  <input type="range" [min]="getSliderMin()" [max]="getSliderMax()" [step]="getSliderStep()"
                    [(ngModel)]="maxValue" (input)="onSliderChange()"
                    class="absolute z-10 w-full h-[55px] bg-transparent pointer-events-none appearance-none" />

                  <!-- Visual Track -->
                  <div class="absolute top-1/2 w-full h-2 bg-gray-300 rounded transform -translate-y-1/2 z-0"></div>
                  <div class="absolute top-1/2 h-2 bg-blue-500 rounded transform -translate-y-1/2 z-0" [ngStyle]="{
                      left:
                        ((minValue - getSliderMin()) /
                          (getSliderMax() - getSliderMin())) *
                          100 +
                        '%',
                      right:
                        100 -
                        ((maxValue - getSliderMin()) /
                          (getSliderMax() - getSliderMin())) *
                          100 +
                        '%',
                    }"></div>
                </div>

                <!-- Radio Buttons -->
                <div class="flex flex-col gap-2">
                  <label class="flex items-center gap-2 text-sm font-medium text-gray-800 py-0 sm:py-1"
                    *ngFor="let option of radioOptions">
                    <input type="radio" name="price-range" [value]="option" [(ngModel)]="selectedRadio"
                      (change)="onRadioSelect(option)" />
                    {{ option.label }}
                  </label>
                </div>
              </div>
            </div>

            <!-- Location Tab -->
            <div *ngIf="activeTab === 'Location'">
              <div class="w-full p-3 sm:pl-1 inline-flex flex-col justify-start items-start gap-4 overflow-hidden">
                <div class="w-full mb-4 relative">
                  <input type="text" [(ngModel)]="locationSearch" placeholder="Search Location"
                    class="w-full p-2 pr-8 rounded-md outline outline-1 outline-gray-300 text-sm placeholder-gray-400" />
                  <div class="absolute top-1/2 right-2 transform -translate-y-1/2">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                      class="w-4 h-4 text-gray-500">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M21 21l-4.35-4.35M10.5 17a6.5 6.5 0 100-13 6.5 6.5 0 000 13z" />
                    </svg>
                  </div>
                </div>

                <!-- Title -->
                <div class="justify-start text-Text-Black text-lg font-bold leading-normal">
                  Popular Locations
                </div>

                <!-- Locations List -->
                <div *ngFor="let location of filteredLocations()"
                  class="self-stretch inline-flex justify-start items-center gap-2">
                  <input type="checkbox" class="w-4 h-4 rounded border border-gray-300" [checked]="location.selected"
                    (change)="toggleLocation(location)" />
                  <div class="text-Text-Black text-base font-medium leading-normal">
                    {{ location.name }}
                  </div>
                  <!-- <div class="text-xs text-neutral-500 ml-auto">
                    ({{ location.count }})
                  </div> -->
                </div>
              </div>
            </div>

            <!-- Seller Tab Content -->
            <div *ngIf="activeTab === 'Seller'" class="space-y-4">
              <!-- 🔍 Search Bar -->
              <div class="w-full relative">
                <input type="text" [(ngModel)]="sellerSearch" placeholder="Search Seller"
                  class="w-full p-2 pr-9 rounded-md outline outline-1 outline-gray-300 text-sm placeholder-gray-400" />
                <button type="button"
                  class="absolute top-1/2 right-2 transform -translate-y-1/2 w-6 h-6 flex justify-center items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor"
                    class="w-4 h-4 text-gray-500">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M21 21l-4.35-4.35M10.5 17a6.5 6.5 0 100-13 6.5 6.5 0 000 13z" />
                  </svg>
                </button>
              </div>

              <!-- Category List -->
              <ng-container *ngFor="let category of filteredSellerCategories()">
                <div class="mb-4">
                  <!-- Top Level Category -->
                  <div class="flex gap-10 justify-between items-center w-full whitespace-nowrap">
                    <div class="flex gap-2 items-center text-base text-black">
                      <div class="flex shrink-0 w-5 h-5">
                        <input type="checkbox" class="w-4 h-4 rounded" [checked]="category.selected"
                          (change)="toggleSelection(category, $event)" />
                      </div>
                      <span>{{ category?.name }}</span>
                    </div>
                    <!-- <div class="flex items-center text-xs text-neutral-500 leading-none">
                      <span>({{ category?.count }})</span>
                    </div> -->
                  </div>

                  <!-- Children (Optional) -->
                  <div *ngIf="category.children && category.expanded" class="pl-4 mt-3">
                    <div *ngFor="let child of category.children" class="mb-3">
                      <div class="flex gap-10 justify-between items-center w-full whitespace-nowrap">
                        <div class="flex gap-2 items-center text-base text-black">
                          <div class="flex shrink-0 w-5 h-5">
                            <input type="checkbox" class="w-4 h-4 rounded" [checked]="child.selected"
                              (change)="toggleSelection(child, $event)" />
                          </div>
                          <span>{{ child.label }}</span>
                        </div>
                        <div class="flex items-center text-xs text-neutral-500 leading-none"
                          *ngIf="this.partType === 'Used Part'">
                          <span>({{ child.count }})</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
            <!-- Category Tree -->
            <div class="Categories mb-4 overflow-y-auto" *ngIf="activeTab === 'Categories'">
              <ng-container *ngFor="let category of filtersData?.category">
                <!-- Top Level Category -->
                <div class="Category flex gap-10 justify-between items-center w-full whitespace-nowrap mb-4 sm:mb-5">
                  <div class="flex gap-2 items-center self-stretch my-auto text-base text-black">
                    <div class="flex shrink-0 self-stretch my-auto w-5 h-5">
                      <input type="checkbox" class="w-4 h-4 rounded" [checked]="category?.selected"
                        (change)="toggleSelection(category, $event)" />
                    </div>
                    <span class="self-stretch my-auto">{{
                      category?.name
                      }}</span>
                  </div>
                  <div class="flex items-center self-stretch my-auto text-xs leading-none text-neutral-500">
                    <span class="self-stretch my-auto">({{ category?.count }})</span>
                    <button *ngIf="category.children && category.children.length > 0" (click)="toggleExpand(category)"
                      class="ml-2">
                      <img [src]="
                          category.expanded
                            ? 'https://cdn.builder.io/api/v1/image/assets/TEMP/e00623418da701feb87e5a771cf46df6fd26b971?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7'
                            : 'https://cdn.builder.io/api/v1/image/assets/TEMP/4a08d0b6975bd738fd78e1dd4974551430ef0a2c?placeholderIfAbsent=true&apiKey=cb544d29e73245039207efcd0a1a6bc7'
                        " alt="Expand/collapse"
                        class="object-contain shrink-0 self-stretch my-auto w-6 aspect-square" />
                    </button>
                  </div>
                </div>

                <!-- Nested Children Level 1 -->
                <div *ngIf="
                    category.children &&
                    category.children.length > 0 &&
                    category.expanded
                  " class="pl-4 mt-3">
                  <div *ngFor="let child of category.children" class="mb-3">
                    <div class="w-[207px] sm:w-[full] flex gap-2 justify-between items-center whitespace-nowrap">
                      <div class="flex gap-2 items-center self-stretch my-auto text-base text-black">
                        <div class="flex shrink-0 self-stretch my-auto w-5 h-5">
                          <input type="checkbox" class="w-4 h-4 rounded" [checked]="child.selected"
                            (change)="toggleSelection(child, $event)" />
                        </div>
                        <span class="self-stretch text-[12px] sm:text-base my-auto">{{ child.label | slice: 0 : 24
                          }}</span>
                      </div>
                      <div class="flex items-center self-stretch my-auto text-xs leading-none text-neutral-500"
                        *ngIf="this.partType === 'Used Part'">
                        <span class="self-stretch my-auto">({{ child.count }})</span>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>

  <!-- Footer with Action Buttons -->
  <footer
    class="flex flex-row absolute bottom-0 justify-between items-center gap-2 px-6 py-2 w-full text-base font-bold text-center bg-white border-t border-solid border-t-[color:var(--Neutrals-Light-Grey,#C0C5C7)] max-md:px-5 max-md:max-w-full mt-auto">
    <button (click)="clearFilters()"
      class="flex gap-1 justify-center items-center self-stretch rounded-lg border border-blue-900 p-2 my-auto w-44 rounded-lg text-blue-950">
      <span class="gap-2 self-stretch my-auto">Clear Filter</span>
    </button>
    <button
      class="flex gap-1 justify-center items-center self-stretch p-2 my-auto w-44 text-white rounded-lg bg-blue-950"
      (click)="viewResults()">
      View Results
      <span *ngIf="getTotalFilteredResults() > 0" class="gap-2 self-stretch my-auto">
        ({{ getTotalFilteredResults() }})
      </span>
    </button>
  </footer>
</section>

<!-- Optional overlay that appears behind the sidebar when it's open -->
<div *ngIf="Sidefilter" class="fixed inset-0 bg-black bg-opacity-50 transition-opacity z-10"
  [ngClass]="Sidefilter ? 'opacity-100' : 'opacity-0 pointer-events-none'" (click)="closeFilters()"></div>